import React from 'react'

const Details = ({rowData}) => {
    return (
        <div className="main-form">
          <div className="p-fluid formgrid grid">
            <div className="field col-12 md:col-4">
              <label>Branch Name</label>
              <p>{rowData?.name || "N/A"}</p>
            </div>
            <div className="field col-12 md:col-4">
              <label>District</label>
              <p>{rowData?.district || "N/A"}</p>
            </div>
            <div className="field col-12 md:col-4">
              <label>Region</label>
              <p>{rowData?.region || "N/A"}</p>
            </div>
            <div className="field col-12 md:col-4">
              <label>Area</label>
              <p>{rowData?.area || "N/A"}</p>
            </div>
            <div className="field col-12 md:col-4">
              <label>Branch Code</label>
              <p>{rowData?.branchCode || "N/A"}</p>
            </div>
          </div>
         
        </div>
      );
    };
    

export default Details